export default __webpack_public_path__ + "static/media/Skirmisher's Greatsword.428d0eed.jpg";